import axios from '../../config/axiosConfig';
import {
  GET_SALES_PAID_BILL_REPORT_REQUEST,
  GET_SALES_PAID_BILL_REPORT_SUCCESS,
  GET_SALES_PAID_BILL_REPORT_FAILURE,
  SET_SALES_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST,
  SET_SALES_PAID_BILL_PARTYWISE_REPORT_BILLS,
  SET_SALES_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST,
  SET_SALES_PAID_BILL_BROKERWISE_REPORT_BILLS,
  SET_SALES_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST,
  RESET_SALES_PAID_REPORT
} from '../types/sales-paid-bill-report-types';

export const getSalesPaidBillReport = (params) => {
  return async (dispatch, getState) => {
      try {
          dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST });

          const { auth } = getState();
          const defaultParams = {
            finyearId: auth.finyear?.id,
            companyId: auth.company?.id,
            customerId: auth.user?.Customer_Id,
          };
    
          console.log('params', params);

          const requestParams = { ...defaultParams, ...params };

          return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
            console.log('API Response Data: ', response);
            // Dispatch success action with data
            if (response.data) {
              dispatch({ type: GET_SALES_PAID_BILL_REPORT_SUCCESS, payload: response.data });
            }
            return response;
          }).catch((error) => {
            console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
            dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
            throw error;
          });          
      } catch (error) {
          console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
          dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
          throw error;
      }
  };
};


export const getPartyWisePartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        showPartyList: true
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_SALES_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const getPartyWiseBills = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_SALES_PAID_BILL_PARTYWISE_REPORT_BILLS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const getBrokerWiseBills = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_SALES_PAID_BILL_BROKERWISE_REPORT_BILLS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const getBrokerWiseBrokerList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_SALES_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const getBrokerWisePartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getSalesPaidBillReport', requestParams).then((response) => {
        if (response.data) {
          dispatch({ type: SET_SALES_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GET_SALES_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_SALES_PAID_BILL_REPORT_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const clearSalesPaidBillReport = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_SALES_PAID_REPORT });
  }
}